export const APPS_SET_APPS_LIST = "APPS_SET_APPS_LIST";
export const SELECTED_CATEGORY = "SELECTED_CATEGORY";
export const SELECTED_SORT = "SELECTED_SORT";
export const SET_SORTPARAMS = "SET_SORTPARAMS";
export const APPS_SET_CONTROL_MODE = "APPS_SET_CONTROL_MODE";
export const SET_OPEN_CREATE_APPS_DIALOG = "SET_OPEN_CREATE_APPS_DIALOG";
export const SET_SELECTED_APP = "SET_SELECTED_APP";
export const SET_APP_STATUS = "SET_APP_STATUS";
export const VERIFYSSO = "VERIFYSSO";
